import React, { Fragment, useState, useEffect } from "react";
import { FormControl } from "baseui/form-control";
import { Input, SIZE as ISIZE } from "baseui/input";
import { Textarea, SIZE as TSIZE } from "baseui/textarea";
import ImageUploaderComponent from "../../components/image-uploader/ImageUploaderComponent";
import { Radio, RadioGroup } from "baseui/radio";
import { connect } from "react-redux";
import {
  uploadModelerThumbnailImage,
  updateModeler,
} from "../../redux/modeler/ModelerThunk";
import { getSignedUrl } from "../../helpers/S3Helpers";
import { ACCESS_TYPES } from "../../constants/AppEnums";
import { GET_SIGNED_URL_PATH } from "../../constants/ApiConstants";

function ModelerPropertiesAsideView(props) {
  const [thumbnailImageUrl, setThumbnailImageUrl] = useState(
    props.thumbnailImageUrl
  );
  const [modelerData, setModelerData] = useState({
    description: props.activeModeler?.description || "",
    title: props.activeModeler?.title || "",
  });

  useEffect(() => {
    setModelerData((prevData) => ({
      ...prevData,
      description: props.activeModeler?.description || "",
      title: props.activeModeler?.title || "",
    }));
    if (!props.activeModeler?.thumbnailImage) return;
    getSignedUrl(
      GET_SIGNED_URL_PATH,
      "modeler",
      `${props.activeModeler.id}/${props.activeModeler.thumbnailImage}`
    ).then((url) => {
      setThumbnailImageUrl(url);
    });
  }, [props.activeModeler]);

  const handleUpdate = (updatedProperty, updatedValue) => {
    if (modelerData[updatedProperty] !== updatedValue) {
      const updatedData = { ...modelerData, [updatedProperty]: updatedValue };
      setModelerData(updatedData);
      // props.updateActiveTemplateProperties(updatedData);
    }
  };

  const handleBlur = (propertyName) => {
    if (modelerData[propertyName] !== props.activeModeler[propertyName]) {
      props.updateActiveModelerProperties(props.activeModeler?.id,{
        [propertyName]: modelerData[propertyName],
      });
    }
  };

  return (
    <Fragment>
      <FormControl
        disabled={props.activeModeler?.templateId}
        id="modeler-image"
        label={() => "Modeler Thumbnail Image"}
      >
        <ImageUploaderComponent
          disabled={props.activeModeler?.templateId}
          height={"250px"}
          backgroundImage={thumbnailImageUrl}
          handleUploadFiles={props.uploadThumbnailImage}
        />
      </FormControl>
      <FormControl
        id="modeler-title"
        label={() => "Modeler title"}
        disabled={props.activeModeler?.templateId}
      >
        <Input
          size={ISIZE.mini}
          value={modelerData.title}
          onChange={(e) => handleUpdate("title", e.target.value)}
          onBlur={() => handleBlur("title")}
        />
      </FormControl>
      <FormControl
        disabled={props.activeModeler?.templateId}
        id="modeler-description"
        label={() => "Modeler description"}
        height={"250px"}
        >
        <Textarea
          overrides={
            {
              Input: {
                style: {
                  height: "250px",
                },
              },
            }
          }
          size={TSIZE.mini}
          value={modelerData.description}
          onChange={(e) => handleUpdate("description", e.target.value)}
          onBlur={() => handleBlur("description")}
        />
      </FormControl>
    </Fragment>
  );
}
const mapStateToProps = (state) => {
  return {
    activeModeler: state.modeler.activeModeler,
    thumbnailImageUrl: state.modeler.activeModeler?.thumbnailImageUrl,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateActiveModelerProperties: (modelerId, modeler) => {
      dispatch(updateModeler(modelerId, modeler ));
    },
    uploadThumbnailImage: (imageFile) => {
      dispatch(uploadModelerThumbnailImage(imageFile));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModelerPropertiesAsideView);
